var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoatBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.029,
    height: 21,
    viewBox: "0 0 24.029 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#122256;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M215.03,33.489a1.217,1.217,0,0,0-1.215-1.215H212a1.217,1.217,0,0,0-1.215,1.215v1.817h4.244Z",
    transform: "translate(-200.893 -32.274)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.514,130.044l7.044,1.841v-4.543a.461.461,0,0,0-.461-.461H102.575a.461.461,0,0,0-.461.461v4.543l7.044-1.841a.7.7,0,0,1,.356,0Z",
    transform: "translate(-97.322 -122.441)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.326,234.871a2.971,2.971,0,0,1-1.571-.4,6.035,6.035,0,0,0-.69-.306,4.3,4.3,0,0,0-1.421-.236l2.578-6.489a.429.429,0,0,0-.294-.564l-9.912-2.59L2.1,226.881a.429.429,0,0,0-.294.564l2.572,6.488a4.3,4.3,0,0,0-1.42.238,6.052,6.052,0,0,0-.685.3,2.972,2.972,0,0,1-1.571.4.7.7,0,1,0,0,1.408,4.33,4.33,0,0,0,2.2-.543,4.376,4.376,0,0,1,.588-.258,3.026,3.026,0,0,1,.983-.138c.1,0,.189,0,.274.008a2.949,2.949,0,0,1,1.3.387,4.331,4.331,0,0,0,2.2.543,4.331,4.331,0,0,0,2.2-.543,2.972,2.972,0,0,1,1.571-.4,2.971,2.971,0,0,1,1.571.4,4.33,4.33,0,0,0,2.2.543,4.33,4.33,0,0,0,2.2-.543,2.949,2.949,0,0,1,1.3-.388c.084-.005.173-.008.268-.008a3.034,3.034,0,0,1,.974.135,4.321,4.321,0,0,1,.6.26,4.33,4.33,0,0,0,2.2.543.7.7,0,1,0,0-1.408ZM5.507,227.894l6.33-1.654a.7.7,0,0,1,.356,0l6.33,1.654a.7.7,0,1,1-.356,1.362l-6.153-1.608-6.152,1.608a.7.7,0,1,1-.356-1.362Z",
    transform: "translate(-0.001 -215.279)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatBlue);
export default __webpack_public_path__ + "static/media/boat-blue.20100bf1b37f71580a887b0218abd238.svg";
export { ForwardRef as ReactComponent };